/**
 * Gating for the "Credits toward General Admission" card on the dashboard.
 */

/**
 * Whether the credit tracker (General Admission credits + GPA card) should be
 * hidden for this learner. High-school subdomains never see it, and outside
 * those only earned-admission learners do — being pathways-allowed is not
 * enough. Treats missing learner data as "hide" so an early render before the
 * learner API resolves shows nothing rather than throwing.
 *
 * @param {Object|null|undefined} learnerData - the connector's learnerData model
 * @returns {boolean}
 */
export const shouldRemoveCreditTracker = (learnerData) => {
  const subDomain = learnerData?._partnerURLSubDomain;
  return subDomain === 'hs' || subDomain === 'hs4cc' || !learnerData?._isEarnedAdmission;
};
